import React from 'react';
import { Link } from 'react-router-dom';
import { getPrivacyPolicyPageUrlByCountry } from '../../../UrlUtils';
import { COUNTRY } from '../../../CountryUtils';

const getPrivacyPolicyLink = (text) => (
    <Link
        to={getPrivacyPolicyPageUrlByCountry(COUNTRY.CANADA)}
        target="_blank"
        className={'text-blue-800 underline'}
        rel="noreferrer"
    >
        {text}
    </Link>
);

const TermsOfParticipation = {
    version: '1.0.0',
    element: (
        <div className={'justify-evenly'} data-testid="terms-of-participation">
            <p>
                D. E. Shaw & Co., L.P. (including its employees and affiliates,
                “DESCO”) has developed its Industry Consultant Program (the
                “ICP”) to identify industry professionals and other experts
                whose specialized knowledge or experience may be useful in
                supplementing DESCO’s investment strategies and to arrange
                confidential consultations between such experts and DESCO’s
                research analysts for such purpose (“Consultations”). You have
                been invited to participate in the ICP as a potential consultant
                (“Consultant”) because of your expertise in a subject area in
                which DESCO is seeking to increase its knowledge base.
            </p>
            <br />
            <p>
                Your participation in the ICP, however, is subject to and
                conditioned upon your agreement to abide by the following terms
                of participation (“Terms of Participation”), which are designed
                to ensure compliance with all applicable federal and provincial
                laws, rules and regulations, and any obligations you may owe to
                third parties. By participating in the ICP and thereby having
                accepted these Terms of Participation, you are confirming that
                you have read, understand, and agree to be bound by these Terms
                of Participation. Your participation in the ICP is at all times
                subject to these Terms of Participation, which incorporate our{' '}
                {getPrivacyPolicyLink(
                    'Canada ICP Personal Data Privacy Notice'
                )}{' '}
                (“Privacy Notice”). If you are unwilling or unable to abide by
                any term specified herein, you must refrain from participation
                in the ICP. From time to time, DESCO may require that you
                re-certify your understanding of and agreement to be bound by
                these Terms of Participation. Your failure to do so at any time
                will preclude your further participation in the ICP.
            </p>
            <br />
            <p>
                <b>Eligibility.</b> You are eligible to participate in the ICP
                only if your participation is permitted by, and does not violate
                (a) any obligation you owe to your employer, any company of
                which you are a director, any client of yours, and any other
                third party to whom you owe a fiduciary obligation, (b) any
                court order, or (c) any other legally binding obligation. By
                executing these Terms of Participation, you are representing
                that you have obtained any and all necessary consents and
                authorizations to participate in and be compensated for
                Consultations, and that you have reviewed all of your employment
                and/or consulting agreements (including employee manuals and
                codes of conduct) and these agreements do not prohibit your
                participation in the ICP or your receipt of compensation
                therefor. You agree that DESCO may confirm your procurement of
                the foregoing consents and authorizations with the relevant
                third parties. If your participation in the ICP would violate or
                conflict with (x) any obligation or duty you owe to your
                employer, any company of which you are a director, any client of
                yours, or any other third party to whom you owe a fiduciary
                obligation, (y) any court order, or (z) any other legally
                binding obligation, you must not submit an application to become
                a Consultant or, if you are already a Consultant, you must
                withdraw from the ICP. You agree to notify DESCO immediately in
                writing if and to the extent you are no longer permitted to
                participate in the ICP. By acknowledging your acceptance of
                these Terms of Participation, you certify your eligibility to
                participate in the ICP.
            </p>
            <br />
            <p>
                <b>Applying to Become an ICP Consultant.</b> In order to become
                a Consultant in the ICP, you are required to provide DESCO with
                certain Personal Information (as defined in the{' '}
                {getPrivacyPolicyLink('Privacy Notice')}) about yourself,
                including your contact information, a current resumé, your
                complete employment history, your directorships and consulting
                history for the past six months, and certain other relevant
                background information. We may also conduct Internet searches
                about you to identify any potential history of fraud, insider
                trading, or other similar harms. You agree that the personal
                information that you provide DESCO is true, supportable,
                accurate, and complete. You also agree to confirm the accuracy
                of and/or advise DESCO of any changes in such personal
                information (including, without limitation, any new employment
                or consulting relationships you may have with any organization)
                before accepting any Invitation (as defined below). The Personal
                Information collected, used, and disclosed in connection with
                your participation in the ICP is subject to the terms of the{' '}
                {getPrivacyPolicyLink('Privacy Notice')}. You acknowledge that
                you have reviewed the {getPrivacyPolicyLink('Privacy Notice')},
                which describes the manner and purposes for which DESCO
                processes your personal information, and your rights over your
                personal information. In addition, you are required to deliver
                to DESCO an executed version of these Terms of Participation
                acknowledging your acceptance thereof. Your application will not
                be considered by DESCO until you have submitted all required
                materials.
            </p>
            <br />
            <p>
                You are free to terminate your participation in the ICP at any
                time by sending a written notice of termination via email to
                Brian Seeliger, Senior Vice President, or to his designee, at{' '}
                <a
                    href="mailto:icp-consultants-termination-requests@world.deshaw.com"
                    target="_blank"
                    className={'text-blue-800 underline'}
                    rel="noreferrer"
                >
                    icp-consultants-termination-requests@world.deshaw.com
                </a>
                .
            </p>
            <br />
            <p>
                <b>Invitations to Participate in Consultations.</b> DESCO’s ICP
                manager will contact you if a DESCO research analyst requests
                your participation in a Consultation (an “Invitation”). The ICP
                manager will explain the subject matter of the Consultation and
                the general nature of the questions you will be asked. You are
                free to either accept or reject any Invitation. If you agree to
                participate in a Consultation, however, you agree that your
                participation will be in accordance with the highest ethical
                standards of your industry or profession, all applicable laws,
                rules, and regulations, your obligations and duties to your
                employer, any company of which you are a director, any client of
                yours, and any other third party to whom you owe a fiduciary
                obligation, and these Terms of Participation. You should either
                accept or reject an Invitation by the end of the business day
                following your receipt thereof, unless otherwise specified by
                DESCO in the Invitation. You understand and agree that all
                potential Consultations are subject to prior review by DESCO’s
                Compliance department and that DESCO Compliance personnel and/or
                other persons employed or retained by DESCO may silently monitor
                Consultations, in DESCO’s sole discretion.
            </p>
            <br />
            <p>
                <b>Obligations of Consultants; Prohibited Disclosures.</b> At no
                time during the course of your participation in the ICP or
                otherwise may you disclose to DESCO any (1) Material Nonpublic
                Information, (2) Confidential Information, or (3) Intellectual
                Property, as such terms are defined below, nor may you use
                Material Nonpublic Information, Confidential Information, or
                Intellectual Property in any way in your work for DESCO. If you
                are employed by or serve as a director of a company whose
                securities are publicly-traded, you may not discuss with DESCO
                any aspect of that company’s business or prospects.
            </p>
            <br />
            <p>
                <i>&quot;Material Nonpublic Information&quot;</i> is any
                information regarding a company whose securities are
                publicly-traded that (i) a reasonable investor would consider
                important in making an investment decision regarding such
                securities or is reasonably likely to have an effect upon the
                price of such securities and (ii) has not been effectively
                disclosed in a manner that ensures its availability to the
                investing public or is not already known by the investing
                public. Examples of Material Nonpublic Information about a
                public company may include undisclosed or not-yet-disseminated
                information regarding its earnings, financial performance, or
                forecasts; any mergers, acquisitions, tender offers, or joint
                ventures involving the company; significant changes in its
                assets; its new products or discoveries; significant
                developments regarding its customers or suppliers; changes in
                its control or management; changes in its auditors or auditing
                practices; its bankruptcy or receivership; or any other event
                that is likely to affect the value of its securities.
            </p>
            <br />
            <p>
                <i>&quot;Confidential Information&quot;</i> is information that
                is subject to a duty of confidentiality you owe to a third party
                or that is otherwise misappropriated by you (e.g., information
                provided to you or otherwise obtained by you in connection with
                an employment agreement, fiduciary obligation, professional or
                other code of conduct, or confidentiality agreement; information
                obtained through attendance at an in camera parliamentary
                committee hearing; information offered in return for lavish
                gifts or entertainment; or information procured through illegal
                means).
            </p>
            <br />
            <p>
                <i>&quot;Intellectual Property&quot;</i> is any work of
                authorship, idea, invention, process, trade secret, or
                proprietary information that is protected under intellectual
                property laws (including but not limited to copyright, patent,
                trademark, or trade secret), or that is subject to a contractual
                obligation of nondisclosure or unauthorized use, regardless of
                whether the information is your property or that of some other
                individual or organization.
            </p>
            <br />
            <p>
                You agree that you will cooperate with DESCO and its authorized
                agents in any inquiry relating to your actual or potential
                disclosure of any Material Nonpublic Information, Confidential
                Information, or Intellectual Property.
            </p>
            <br />
            <p>
                <b>Use of Consultant-Provided Information.</b> You understand,
                acknowledge, and agree that the information you provide during a
                Consultation may be used by DESCO for whatever purposes DESCO,
                in its sole discretion, chooses, including trading on such
                information in the public securities markets and otherwise
                complementing its investment strategies. You agree that the
                information you provide will be true, supportable, accurate, and
                complete to the best of your knowledge. DESCO agrees that it
                will not communicate any of such information to unaffiliated
                third parties (except as may be required by law, regulation, or
                court order).
            </p>
            <br />
            <p>
                <b>Special Projects.</b> In the course of your participation in
                the ICP, you may be asked to perform additional services for
                DESCO, which may include the production of written reports or
                presentations. Should you accept any such special project, you
                agree that any right, title, or interest in any materials that
                you develop or produce for DESCO shall be and remain the sole
                and exclusive property of DESCO for all purposes and uses, and
                further that you shall have no right, title, or interest of any
                kind or nature therein, or in any of the results and/or proceeds
                obtained therefrom. You hereby assign to DESCO all right, title
                and interest, including all Intellectual Property rights, in and
                to any materials, works, inventions, or other deliverables that
                you develop or produce in connection with your services to
                DESCO. You further irrevocably and unconditionally waive, and
                agree not to assert, any moral rights you may have under the
                Copyright Act, as amended, or under any similar legislation in
                any jurisdiction. Your compensation for any such special project
                shall be separately negotiated with DESCO and may or may not
                reflect your standard rate of compensation for an ICP
                Consultation.
            </p>
            <br />
            <p>
                <b>Protection of DESCO Confidences.</b> In the course of and
                incident to your participation in the ICP, you may acquire
                valuable and competitively-sensitive proprietary information of
                DESCO’s regarding its current or prospective trading activities,
                investment strategies, or business operations. You agree that
                any such information belongs to DESCO. You agree that (1) you
                will maintain the confidentiality of the information and not use
                the information in any way for your own benefit or the benefit
                of any third party, and (2) you will not, directly or
                indirectly, at any time during your participation in the ICP or
                thereafter, use, disclose, or cause to be used or disclosed any
                information discussed or revealed during the course of a
                Consultation or otherwise acquired by you in connection with
                your participation in the ICP, including the subject matter of a
                Consultation, except as required by law or court order or as
                permitted by the last sentence of this section. Before complying
                with any legally binding request for disclosure of any such
                information, you agree to promptly notify DESCO thereof to the
                fullest extent permitted by law and thereafter to cooperate
                fully with DESCO in protecting such information to the extent
                legally possible. Except as aforesaid, you further agree that
                you will not disclose the fact that you are participating in the
                ICP or these Terms of Participation to any third party other
                than your employer, a company of which you are a director, or,
                solely for the purpose of obtaining their advice with respect to
                your participation in the ICP, your legal and financial
                advisers. Notwithstanding anything to the contrary in these
                Terms of Participation, you shall be free, without notice to
                DESCO, to communicate directly with and provide confidential
                information regarding DESCO, including documents, to any
                regulator or other national, federal, provincial, or local
                governmental agencies or commissions regarding possible
                violations of law or regulation.
            </p>
            <br />
            <p>
                <b>Relationship of the Parties.</b> You agree that your
                relationship with DESCO is solely that of an independent
                contractor. Unless otherwise specified by DESCO, each
                Consultation is a discrete, stand-alone engagement. Although
                your agreement to abide by these Terms of Participation
                continues to apply throughout your participation in the ICP and
                thereafter, your services on behalf of DESCO will terminate at
                the conclusion of each Consultation, unless and until you are
                invited to participate in a subsequent Consultation. Nothing
                contained in these Terms of Participation, and no modification
                of your responsibilities or the terms of your compensation made
                hereafter, shall be construed to change your status with DESCO.
                You agree that you are not an employee, partner, legal
                representative, or agent of DESCO for any purpose whatsoever.
                You are not entitled to any benefit provided by DESCO to its
                employees and DESCO shall not make any deductions from payments
                to you to account for your tax liability. You will be personally
                responsible for any and all taxes you may be obligated to pay as
                a result of any compensation paid to you by DESCO.
            </p>
            <br />
            <p>
                <b>Compensation.</b> Your compensation for a Consultation will
                be based on the amount of time you spend during the Consultation
                and the customary hourly rate for an expert with similar
                expertise and experience to yours. The applicable rate shall be
                agreed upon by you and DESCO in writing in advance of any
                Consultation. Reimbursement for reasonable ICP-related expenses
                including travel is permitted only with prior written approval
                from DESCO and upon documentation by you of all such expenses in
                such detail as shall be satisfactory to DESCO in its sole
                discretion. In the event you do not obtain prior written
                approval from DESCO or provide DESCO with satisfactory
                documentation of expenses, DESCO shall not have any obligation
                (under these Terms of Participation or otherwise) to reimburse
                you for such expenses. Upon the completion of each Consultation,
                you shall submit an invoice to DESCO covering the agreed-upon
                fees and approved expenses which will be paid to you within
                thirty (30) days thereafter. The fees and expenses described in
                this section shall be the exclusive compensation due to you from
                DESCO during or on account of the Consultation.
            </p>
            <br />
            <p>
                <b>Indemnification.</b> You waive any right to recover damages
                from DESCO or to seek any other form of relief based on an
                allegation of misappropriation, theft, unauthorized use, or
                disclosure by DESCO of any information provided by you during
                the course of your participation in the ICP. You further agree
                to indemnify, defend, and hold harmless DESCO against any action
                by a third party in connection with an alleged disclosure by you
                of Material Nonpublic Information, Confidential Information, or
                Intellectual Property or in connection with an alleged breach of
                fiduciary duty owed by you to your employer, any company of
                which you are a director, any client of yours, or any other
                third party.
            </p>
            <br />
            <p>
                <b>Limitation of Liability.</b> You agree that in no event
                whatsoever shall DESCO be liable to you or any other party for
                any damages resulting from your participation in the ICP or any
                Consultation. In no event whatsoever shall DESCO be liable to
                you or any third party for any indirect, special, incidental,
                consequential, or punitive damages, whether brought as a
                contract, tort or strict liability claim.
            </p>
            <br />
            <p>
                <b>Entire Agreement.</b> These Terms of Participation, which
                incorporate your completed application to participate in the
                ICP, constitute the entire agreement between you and DESCO and
                shall supersede any and all existing agreements between you and
                DESCO relating to the subject matter hereof. You acknowledge
                that in choosing to accept these Terms of Participation, you
                have not relied on any warranties, representations, or promises
                by DESCO, its employees, or any other parties except as
                specifically set forth herein.
            </p>
            <br />
            <p>
                <b>Governing Law and Venue Restriction.</b> Any dispute arising
                out of your participation in the ICP shall be governed by, and
                construed in accordance with, the laws of the State of New York,
                without regard to conflicts-of-law principles. The parties
                hereby agree that the exclusive venue for resolving any disputes
                arising under these Terms of Participation shall be any court of
                competent jurisdiction located in the State of New York and the
                County of New York.
            </p>
        </div>
    ),
};

export default TermsOfParticipation;
